var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{style:(_setup.appStyles),attrs:{"data-testid":"app"}},[_c('v-main',[(
        _setup.route.path !== '/login' &&
        !_setup.route.path.includes('/approval-proposal') &&
        !_setup.route.path.includes('/approval-requisition') &&
        !_setup.route.path.includes('/checklist-vehicle') &&
        !_setup.route.path.includes('/approval-techlist-purchase-request') &&
        !_setup.route.path.includes('/assinar-proposta')
      )?_c(_setup.AppBar,{staticStyle:{"z-index":"7"}}):_vm._e(),_c('transition',{attrs:{"name":"fadeRouter","mode":"out-in"}},[_c('router-view')],1)],1),_c(_setup.SessionExpiredDialog),_c(_setup.ReloadDialog),_c(_setup.AtmoAssistantDialog)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }